var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookSection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 649,
    height: 965,
    viewBox: "0 0 649 965",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_135_378",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 649,
    height: 965
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 649,
    height: 965,
    fill: "#2B5CFF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_135_378)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 120.625L91.6746 0.000118381L189.13 0L94.1523 120.625H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.478 120.625L235.153 0.000118381L332.609 0L237.631 120.625H143.478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.957 120.625L378.631 0.000118381L476.087 0L381.109 120.625H286.957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.435 120.625L522.109 0.000118381L619.565 0L524.587 120.625H430.435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.913 120.625L665.588 0.000118381L763.043 0L668.065 120.625H573.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.391 120.625L809.066 0.000118381L906.522 0L811.544 120.625H717.391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.87 120.625L952.544 0.000118381L1050 0L955.022 120.625H860.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 241.25L91.6746 120.625L189.13 120.625L94.1523 241.25H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.478 241.25L235.153 120.625L332.609 120.625L237.631 241.25H143.478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.957 241.25L378.631 120.625L476.087 120.625L381.109 241.25H286.957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.435 241.25L522.109 120.625L619.565 120.625L524.587 241.25H430.435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.913 241.25L665.588 120.625L763.043 120.625L668.065 241.25H573.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.391 241.25L809.066 120.625L906.522 120.625L811.544 241.25H717.391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.87 241.25L952.544 120.625L1050 120.625L955.022 241.25H860.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 361.875L91.6746 241.25L189.13 241.25L94.1523 361.875H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.478 361.875L235.153 241.25L332.609 241.25L237.631 361.875H143.478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.957 361.875L378.631 241.25L476.087 241.25L381.109 361.875H286.957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.435 361.875L522.109 241.25L619.565 241.25L524.587 361.875H430.435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.913 361.875L665.588 241.25L763.043 241.25L668.065 361.875H573.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.391 361.875L809.066 241.25L906.522 241.25L811.544 361.875H717.391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.87 361.875L952.544 241.25L1050 241.25L955.022 361.875H860.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 482.5L91.6746 361.875L189.13 361.875L94.1523 482.5H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.478 482.5L235.153 361.875L332.609 361.875L237.631 482.5H143.478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.957 482.5L378.631 361.875L476.087 361.875L381.109 482.5H286.957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.435 482.5L522.109 361.875L619.565 361.875L524.587 482.5H430.435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.913 482.5L665.588 361.875L763.043 361.875L668.065 482.5H573.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.391 482.5L809.066 361.875L906.522 361.875L811.544 482.5H717.391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.87 482.5L952.544 361.875L1050 361.875L955.022 482.5H860.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 603.125L91.6746 482.5L189.13 482.5L94.1523 603.125H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.478 603.125L235.153 482.5L332.609 482.5L237.631 603.125H143.478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.957 603.125L378.631 482.5L476.087 482.5L381.109 603.125H286.957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.435 603.125L522.109 482.5L619.565 482.5L524.587 603.125H430.435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.913 603.125L665.588 482.5L763.043 482.5L668.065 603.125H573.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.391 603.125L809.066 482.5L906.522 482.5L811.544 603.125H717.391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.87 603.125L952.544 482.5L1050 482.5L955.022 603.125H860.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 723.75L91.6746 603.125L189.13 603.125L94.1523 723.75H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.478 723.75L235.153 603.125L332.609 603.125L237.631 723.75H143.478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.957 723.75L378.631 603.125L476.087 603.125L381.109 723.75H286.957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.435 723.75L522.109 603.125L619.565 603.125L524.587 723.75H430.435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.913 723.75L665.588 603.125L763.043 603.125L668.065 723.75H573.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.391 723.75L809.066 603.125L906.522 603.125L811.544 723.75H717.391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.87 723.75L952.544 603.125L1050 603.125L955.022 723.75H860.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 844.375L91.6746 723.75L189.13 723.75L94.1523 844.375H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.478 844.375L235.153 723.75L332.609 723.75L237.631 844.375H143.478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.957 844.375L378.631 723.75L476.087 723.75L381.109 844.375H286.957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.435 844.375L522.109 723.75L619.565 723.75L524.587 844.375H430.435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.913 844.375L665.588 723.75L763.043 723.75L668.065 844.375H573.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.391 844.375L809.066 723.75L906.522 723.75L811.544 844.375H717.391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.87 844.375L952.544 723.75L1050 723.75L955.022 844.375H860.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 965L91.6746 844.375L189.13 844.375L94.1523 965H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.478 965L235.153 844.375L332.609 844.375L237.631 965H143.478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.957 965L378.631 844.375L476.087 844.375L381.109 965H286.957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.435 965L522.109 844.375L619.565 844.375L524.587 965H430.435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.913 965L665.588 844.375L763.043 844.375L668.065 965H573.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.391 965L809.066 844.375L906.522 844.375L811.544 965H717.391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.87 965L952.544 844.375L1050 844.375L955.022 965H860.87Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookSection);
export default __webpack_public_path__ + "static/media/book_section.bbee8f293238008a87d95dbd1abc913e.svg";
export { ForwardRef as ReactComponent };